import Vue from 'vue'
import VueRouter from 'vue-router'
import {authGuard} from "@/router/guards";

Vue.use(VueRouter)

const routes = [
    //App main
    {
        path: '/',
        name: 'Login',
        component: () => import('@/views/Auth'),
        productionAvailable: true
    },
    {
        path: '/app-select',
        name: 'AppSelect',
        component: () => import('@/views/AppSelect'),
        productionAvailable: true
    },
    {
        path: '/:app/menu',
        name: 'Home',
        beforeEnter: authGuard,
        component: () => import('@/views/Home'),
        productionAvailable: true
    },

    //Maturity rating digital
    {
        path: '/:app/maturity-rating-digital',
        name: 'Maturity Rating Digital',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Global/MaturityRatingDigital'),
        productionAvailable: true
    },

    //Roadmap virtual tdc
    //TDC
    {
        path: '/:app/roadmap-virtual-tdc',
        name: 'TDC Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Tdc/RoadmapVirtualTdc'),
        productionAvailable: true
    },

    //Maad'en
    {
        path: '/:app/roadmap-virtual-maaden',
        name: 'Ma\'aden Executive Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Maaden/Executive/RoadmapVirtualTdc'),
        productionAvailable: true
    },
    {
        path: '/:app/roadmap-virtual-maaden',
        name: 'Ma\'aden Director Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Maaden/Director/RoadmapVirtualTdc'),
        productionAvailable: true
    },

    //GHC
    {
        path: '/:app/roadmap-virtual-ghc',
        name: 'GHC Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Ghc/RoadmapVirtualGhc'),
        productionAvailable: true
    },

    //Eskom
    {
        path: '/:app/roadmap-virtual-eskom',
        name: 'Eskom Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Eskom/RoadmapVirtualEskom'),
        productionAvailable: true
    },

    //SEC
    {
        path: '/:app/roadmap-virtual-sec',
        name: 'SEC Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Sec/RoadmapVirtualSec'),
        productionAvailable: true
    },

    //SPB
    {
        path: '/:app/roadmap-virtual-spb',
        name: 'SPB Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Spb/RoadmapVirtualSpb.vue'),
        productionAvailable: true
    },

    //Fitt
    {
        path: '/:app/roadmap-for-training',
        name: 'Roadmap For Training',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Fat/RoadmapForTraining'),
        productionAvailable: true
    },

    //Medihelp
    {
        path: '/:app/roadmap-virtual-medihelp',
        name: 'Medihelp Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Medihelp/RoadmapVirtualTdc'),
        productionAvailable: true
    },

    //NOMAC
    {
        path: '/:app/roadmap-virtual-nomac-n3',
        name: 'NOMAC N3 Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Nomac/NomacRoadmapVirtualTdc'),
        productionAvailable: true
    },
    {
        path: '/:app/roadmap-virtual-nomac-n4',
        name: 'NOMAC N4 Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Nomac/NomacRoadmapVirtualTdc'),
        productionAvailable: true
    },

    //QAFCO
    {
        path: '/:app/roadmap-virtual-qafco',
        name: 'QAFCO Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Qafco/QafcoRoadmapVirtualTdc'),
        productionAvailable: true
    },

    //Armscor
    {
        path: '/:app/roadmap-virtual-armscor',
        name: 'Armscor Roadmap Virtual Tdc',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Armscor/RoadmapVirtualArmscor'),
        productionAvailable: true
    },

    //CEO for a day
    //TDC
    {
        path: '/:app/tdc-ceo-for-a-day',
        name: 'TDC CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Tdc/TdcCeoForADay'),
        productionAvailable: true
    },

    //Merdidian
    {
        path: '/:app/meridian-ceo-for-a-day',
        name: 'Meridian CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Meridian/MeridianCeoForADay'),
        productionAvailable: true
    },

    //GHC
    {
        path: '/:app/ghc-ceo-for-a-day',
        name: 'GHC CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Ghc/GhcCeoForADay'),
        productionAvailable: true
    },

    //SEC
    {
        path: '/:app/sec-ceo-for-a-day',
        name: 'SEC CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Sec/SecCeoForADay'),
        productionAvailable: true
    },

    //SPB
    {
        path: '/:app/spb-ceo-for-a-day',
        name: 'SPB CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Spb/SpbCeoForADay'),
        productionAvailable: true
    },

    //Medihelp
    {
        path: '/:app/medihelp-ceo-for-a-day',
        name: 'Medihelp CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Medihelp/MedihelpCeoForADay'),
        productionAvailable: true
    },

    //Maad'en
    {
        path: '/:app/maaden-exec-ceo-for-a-day',
        name: 'Maaden Exec CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Maaden/Executive/MaadenExecCeoForADay'),
        productionAvailable: true
    },
    {
        path: '/:app/maaden-direc-ceo-for-a-day',
        name: 'Maaden Direc CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Maaden/Director/MaadenDirecCeoForADay'),
        productionAvailable: true
    },

    //Eskom
    {
        path: '/:app/eskom-ceo-for-a-day',
        name: 'Eskom CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Eskom/EskomCeoForADay'),
        productionAvailable: true
    },

    //NOMAC
    {
        path: '/:app/nomac-n3-ceo-for-a-day',
        name: 'NOMAC N3 CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Nomac/N3CeoForADay'),
        productionAvailable: true
    },
    {
        path: '/:app/nomac-n4-ceo-for-a-day',
        name: 'NOMAC N4 CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Nomac/N4CeoForADay'),
        productionAvailable: true
    },

    //QAFCO
    {
        path: '/:app/qafco-ceo-for-a-day',
        name: 'QAFCO CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Qafco/QafcoCeoForADay'),
        productionAvailable: true
    },

    //Armscor
    {
        path: '/:app/armscor-ceo-for-a-day',
        name: 'Armscor CEO for a Day',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Armscor/ArmscorCeoForADay'),
        productionAvailable: true
    },

    //Leadership game
    //PWC
    {
        path: '/:app/pwc-leadership-game',
        name: 'PwC Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Tdc/PwcLeadershipGame'),
        productionAvailable: true
    },

    //Eskom
    {
        path: '/:app/eskom-leadership-game',
        name: 'Eskom Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Eskom/EskomLeadershipGame'),
        productionAvailable: true
    },

    //Merdidian
    {
        path: '/:app/meridian-leadership-game',
        name: 'Meridian Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Meridian/MeridianLeadershipGame'),
        productionAvailable: true
    },

    //GHC
    {
        path: '/:app/ghc-leadership-game',
        name: 'GHC Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Ghc/GhcLeadershipGame'),
        productionAvailable: true
    },

    //Medihelp
    {
        path: '/:app/medihelp-leadership-game',
        name: 'Medihelp Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Medihelp/MedihelpLeadershipGame'),
        productionAvailable: true
    },

    //Fitt decision game
    {
        path: '/:app/the-fitt-decision-game',
        name: 'The Fitt Decision Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Fat/TheFittDecisionGame'),
        productionAvailable: true
    },
    //Sec Peak
    {
        path: '/:app/edge-ev-phase-2',
        name: 'Marketing',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/SecPeak/SecPeakPhase2'),
        productionAvailable: true
    },
    {
        path: '/:app/fusion',
        name: 'Fusion',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/SecPeak/SecPeakFusion'),
        productionAvailable: true
    },

    //Armscor
    {
        path: '/:app/armscor-leadership-game',
        name: 'Armscor Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Armscor/ArmscorLeadershipGame'),
        productionAvailable: true
    },

    //Other tools
    //Leader of the future
    {
        path: '/:app/leader-of-the-future',
        name: 'The Leader of the Future',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Peak/FutureLeader'),
        productionAvailable: true
    },

    //Development plan design
    {
        path: '/:app/development-plan',
        name: 'Designing a Development Plan',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Peak/DevelopmentPlan'),
        productionAvailable: true
    },

    //Peak leadership game
    {
        path: '/:app/peak-leadership-game',
        name: 'PEAK Leadership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Peak/PeakLeadershipGame'),
        productionAvailable: true
    },

    //NOMAC career ownership game
    {
        path: '/:app/nomac-career-ownership-game',
        name: 'NOMAC Career Ownership Game',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Nomac/NomacCareerOwnershipGame'),
        productionAvailable: true
    },

  //General Fusion
    {
        path: '/:app/general-fusion',
        name: 'Fusion',
        beforeEnter: authGuard,
        component: () => import('@/views/Tools/Fusion/Fusion'),
        productionAvailable: true
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: process.env.NODE_ENV === 'production' ? routes.filter((route) => route.productionAvailable) : routes,
})

export default router
